<template>
    <el-button type="danger" plain  icon="el-icon-delete" v-on:click="clickEvent()">{{btnCon}}</el-button>
</template>
  
  <script>
  
  export default {
    name: 'drop-button',
    props: {
      btnCon: {
            type: String,
            default: () => {
                return "删除"
            }
        },
    },
    data () {
      return {
      }
    },
    mounted () {
    },
    methods: {
        clickEvent(){
            this.$emit('select-type',1);
        }
    }
  }
  </script>
  
  <style lang="scss">
  </style>
  


// WEBPACK FOOTER //
// DropButton.vue?840441e2